import React, { useEffect, useRef, useState } from 'react';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { assets, business, navLinks } from '../data/content';
export function Header() {
  const [open, setOpen] = useState(false);
  const toggleRef = useRef<HTMLButtonElement>(null);
  const panelRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    function onKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        setOpen(false);
        toggleRef.current?.focus();
      }
    }
    document.addEventListener('keydown', onKeyDown);
    const firstLink = panelRef.current?.querySelector<HTMLAnchorElement>('a');
    firstLink?.focus();
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open]);
  return <header className="sticky top-0 z-50 w-full" data-id="element-91" data-mp="36cw9h04gjxh2">
      {/* Utility strip */}
      <div className="bg-ink text-warm" data-id="element-92" data-mp="3bbzg2p036br5">
        <div className="mx-auto flex h-11 max-w-shell items-center justify-between gap-x-6 px-5 lg:px-8" data-id="element-93" data-mp="3fbgkrg7ov4v9">
          <p className="max-w-[48rem] text-[11px] font-semibold leading-[15px] text-warm sm:text-xs lg:text-[13px]" data-id="element-94" data-mp="2wldwxpm955aa">
            Utility &amp; Commercial Fence Contractor Serving Michigan, Indiana &amp; Ohio
          </p>
          <a href={business.phoneHref} className="hidden min-h-[44px] shrink-0 items-center gap-2 text-sm font-semibold text-warm transition-colors duration-150 ease-industrial hover:text-safety sm:inline-flex" data-id="element-95" data-mp="2mng7wzwkj4gm">
            <PhoneIcon aria-hidden="true" className="h-4 w-4" data-id="element-96" data-mp="3fd6rvpkvt0kn" />
            <span data-id="element-97" data-mp="3acrbep5azcyg">{business.phone}</span>
          </a>
        </div>
      </div>

      <div className="border-b border-steel-100 bg-white" data-id="element-98" data-mp="35khgeupbzmpb">
        <div className="mx-auto flex h-[90px] max-w-shell items-center justify-between px-5 lg:px-8" data-id="element-99" data-mp="30mfve48chdb7">
          <a href="#top" className="flex shrink-0 items-center" aria-label="South Lyon Fence — home" data-id="element-100" data-mp="1wftkz9gcx2m">
            <img src={assets.logo} alt="South Lyon Fence" width={184} height={83} className="h-[68px] w-auto [filter:contrast(1.25)] lg:h-[78px]" data-id="element-101" data-mp="3tbdf8bs7fi62" />
          </a>

          <nav aria-label="Primary" className="hidden items-center gap-6 lg:flex" data-id="element-102" data-mp="1wbcw1c7ml648">
            {navLinks.map(link => <a key={link.href} href={link.href} className="font-display text-[17px] uppercase tracking-[0.1em] text-ink transition-colors duration-150 ease-industrial hover:text-steel" data-id="element-103" data-mp="1hlnql4si2fy5">
                {link.label}
              </a>)}
            <a href="#contact" className="inline-flex min-h-[44px] items-center rounded-sm bg-safety px-6 font-display text-[17px] uppercase tracking-[0.08em] text-ink transition-colors duration-150 ease-industrial hover:bg-safety-600" data-id="element-104" data-mp="1cmc7hp4nuyde">
              Discuss your project
            </a>
          </nav>

          <button ref={toggleRef} type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-controls="mobile-menu" className="inline-flex h-11 min-w-[44px] items-center gap-2 rounded-sm border border-ink px-3 font-display text-base uppercase tracking-[0.1em] text-ink lg:hidden" data-id="element-105" data-mp="2y0yp815xon5n">
            {open ? <XIcon aria-hidden="true" className="h-5 w-5" data-id="element-106" data-mp="rczhpljyi06t" /> : <MenuIcon aria-hidden="true" className="h-5 w-5" data-id="element-107" data-mp="154cwynau0bw1" />}
            <span data-id="element-108" data-mp="106bcpz1o66iz">{open ? 'Close' : 'Menu'}</span>
          </button>
        </div>
      </div>

      <div id="mobile-menu" ref={panelRef} hidden={!open} className="border-b border-ink-700 bg-ink lg:hidden" data-id="element-109" data-mp="1f324pn90kfyk">
        <nav aria-label="Primary mobile" className="mx-auto max-w-shell px-5 py-3" data-id="element-110" data-mp="1a4s9xdr7bhdh">
          <ul className="divide-y divide-ink-700" data-id="element-111" data-mp="3gvqe6ec93zms">
            {navLinks.map(link => <li key={link.href} data-id="element-112" data-mp="3bwni3je913qy">
                <a href={link.href} onClick={() => setOpen(false)} className="flex min-h-[52px] items-center font-display text-xl uppercase tracking-[0.08em] text-warm" data-id="element-113" data-mp="3bxgi81ipcv04">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <a href="#contact" onClick={() => setOpen(false)} className="mt-4 flex min-h-[52px] items-center justify-center rounded-sm bg-safety px-6 font-display text-xl uppercase tracking-[0.08em] text-ink" data-id="element-114" data-mp="2gy6m3ts2x4gk">
            Discuss your project
          </a>
          <a href={business.phoneHref} className="mt-2 flex min-h-[52px] items-center justify-center gap-2 text-base font-medium text-warm" data-id="element-115" data-mp="1t8c7p7s437u7">
            <PhoneIcon aria-hidden="true" className="h-4 w-4" data-id="element-116" data-mp="1y1f0vesz8f9v" />
            {business.phone}
          </a>
        </nav>
      </div>
    </header>;
}